// eslint-disable-next-line no-unused-vars
import { Message } from 'element-ui';

function message (type, message) {
  Message({
    showClose: true,
    duration: 2000,
    message,
    type
  });
}

export function megSuc (txt) {
  message('success', txt);
}

export function megError (txt) {
  message('error', txt);
}

export function megWarn (txt) {
  message('warning', txt);
}

export function megInfo (txt) {
  message('info', txt);
}
